import { render, staticRenderFns } from "./PrivateRecords.vue?vue&type=template&id=ac1f532e&scoped=true"
import script from "./PrivateRecords.vue?vue&type=script&lang=js"
export * from "./PrivateRecords.vue?vue&type=script&lang=js"
import style0 from "./PrivateRecords.vue?vue&type=style&index=0&id=ac1f532e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1f532e",
  null
  
)

export default component.exports